/* Hondeland - interactieve productpagina */
(function () {
if (window.__pzInit) { return; }
window.__pzInit = true;
var d = document;
d.documentElement.classList.add('pz-js');
var mm = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
var reduce = mm('(prefers-reduced-motion: reduce)');
var fine = mm('(hover: hover) and (pointer: fine)');
var hasIO = 'IntersectionObserver' in window;
function qa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function playSafe(v) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
function near(el, cb) {
if (!hasIO) { cb(); return; }
var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { o.disconnect(); cb(); } }, { rootMargin: '900px 0px' });
o.observe(el);
}
function vis(el, cb, th) {
if (!hasIO) { cb(true); return; }
var o = new IntersectionObserver(function (es) { cb(es[0].isIntersecting); }, { threshold: th || 0.15 });
o.observe(el);
}
function ensureSrc(v) {
if (v.__src) { return; }
v.__src = 1;
var s = v.getAttribute('data-src');
if (s && !v.getAttribute('src')) { v.src = s; v.load(); }
}

/* reveal + gesplitste koppen */
var rio = hasIO ? new IntersectionObserver(function (es) {
es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
}, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }) : null;
function split(el, cls) {
var txt = el.textContent.trim();
var words = txt.split(/\s+/);
el.setAttribute('aria-label', txt);
el.innerHTML = words.map(function (w, i) {
return cls === 'w' ? '<span class="w" aria-hidden="true"><span style="--i:' + i + '">' + esc(w) + '</span></span>' : '<span class="pz-word" aria-hidden="true" style="--i:' + i + '">' + esc(w) + '</span>';
}).join(' ');
el.style.setProperty('--n', words.length);
}
function initReveal(scope) {
qa('[data-pz-split]', scope).forEach(function (el) { if (el.__pzs) { return; } el.__pzs = 1; split(el, 'w'); el.classList.add('pz-split'); });
qa('[data-pz-words]', scope).forEach(function (el) { if (el.__pzw) { return; } el.__pzw = 1; split(el, 'word'); });
qa('[data-pz-reveal],[data-pz-split]', scope).forEach(function (el) {
if (el.__pzr) { return; }
el.__pzr = 1;
if (rio && !reduce) { rio.observe(el); } else { el.classList.add('is-in'); }
});
}

/* scroll-voortgang (--p) */
var scrollEls = [];
var ticking = false;
function tick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
function update() {
ticking = false;
var vh = window.innerHeight;
scrollEls.forEach(function (el) {
if (!el.isConnected) { return; }
var r = el.getBoundingClientRect();
if (r.bottom < -vh || r.top > vh * 2) { return; }
var total = r.height - vh;
var p = total > 0 ? clamp(-r.top / total, 0, 1) : clamp((vh - r.top) / (vh + r.height), 0, 1);
el.style.setProperty('--p', p.toFixed(4));
if (el.__onp) { el.__onp(p); }
});
}
window.addEventListener('scroll', tick, { passive: true });
window.addEventListener('resize', tick);
function initScroll(scope) {
qa('[data-pz-scroll]', scope).forEach(function (el) { if (el.__pzsc) { return; } el.__pzsc = 1; scrollEls.push(el); });
tick();
}

/* video's: autoplay in beeld */
function initAutoplay(scope) {
qa('video[data-pz-autoplay]', scope).forEach(function (v) {
if (v.__pza) { return; }
v.__pza = 1;
v.muted = true; v.playsInline = true;
near(v, function () { ensureSrc(v); });
vis(v, function (on) {
if (on && !reduce) { ensureSrc(v); playSafe(v); } else { v.pause(); }
}, 0.2);
});
}

/* verhaal-secties */
function setActive(steps, idx) {
steps.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); s.classList.toggle('is-done', i < idx); });
}
function initScrub(el, steps) {
var v = el.querySelector('video[data-pz-scrub]');
var bar = el.querySelector('[data-pz-bar]');
var target = 0, cur = 0, raf = 0, ready = false;
function seek() {
if (!v || !ready || !v.duration || reduce) { return; }
cancelAnimationFrame(raf);
raf = requestAnimationFrame(function stepFn() {
var t = target * (v.duration - 0.06);
cur += (t - cur) * 0.2;
if (Math.abs(t - cur) < 0.008) { cur = t; }
if (Math.abs(v.currentTime - cur) > 0.015) { try { v.currentTime = cur; } catch (e) {} }
if (cur !== t) { raf = requestAnimationFrame(stepFn); }
});
}
if (v) {
v.muted = true; v.playsInline = true;
v.addEventListener('loadedmetadata', function () { ready = true; seek(); });
v.addEventListener('loadeddata', function () { ready = true; seek(); });
near(el, function () {
if (v.__primed) { return; }
v.__primed = 1;
v.preload = 'auto';
v.load();
var pr = v.play();
if (pr && pr.then) { pr.then(function () { v.pause(); ready = true; seek(); }).catch(function () {}); }
});
}
el.__onp = function (p) {
target = p;
seek();
if (bar) { bar.style.transform = 'scaleX(' + p.toFixed(4) + ')'; }
el.classList.toggle('pz-moved', p > 0.03);
var mid = window.innerHeight * 0.55, best = 0, bd = 1e9;
steps.forEach(function (s, i) {
var r = s.getBoundingClientRect();
var dd = Math.abs(r.top + r.height / 2 - mid);
if (dd < bd) { bd = dd; best = i; }
});
setActive(steps, best);
};
}
function initPlayer(el, steps) {
var slides = qa('[data-pz-slide]', el);
var segs = qa('[data-pz-seg]', el);
var idx = 0, raf = 0, inView = false, t0 = 0, IMG = 4500;
function show(i) {
idx = (i + steps.length) % steps.length;
setActive(steps, idx);
slides.forEach(function (m, j) {
m.classList.toggle('is-on', j === idx);
var v = m.querySelector('video');
if (!v) { return; }
if (j === idx) {
ensureSrc(v);
try { v.currentTime = 0; } catch (e) {}
if (inView && !reduce) { playSafe(v); }
} else { v.pause(); }
});
segs.forEach(function (b, j) { b.style.transform = j < idx ? 'scaleX(1)' : 'scaleX(0)'; });
t0 = performance.now();
}
function loop(now) {
if (!inView) { return; }
var m = slides[idx];
var v = m && m.querySelector('video');
var prog;
if (v && v.duration && !reduce) {
prog = v.currentTime / v.duration;
if (v.ended || prog > 0.992) { show(idx + 1); prog = 0; }
} else {
prog = (now - t0) / IMG;
if (prog >= 1) { show(idx + 1); prog = 0; }
}
if (segs[idx]) { segs[idx].style.transform = 'scaleX(' + clamp(prog, 0, 1).toFixed(3) + ')'; }
raf = requestAnimationFrame(loop);
}
steps.forEach(function (s, i) {
s.setAttribute('tabindex', '0');
s.setAttribute('role', 'button');
s.addEventListener('click', function () { show(i); });
s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i); } });
});
near(el, function () { slides.forEach(function (m) { var v = m.querySelector('video'); if (v) { v.preload = 'auto'; ensureSrc(v); } }); });
vis(el, function (on) {
inView = on;
cancelAnimationFrame(raf);
if (on) { show(idx); raf = requestAnimationFrame(loop); }
else { slides.forEach(function (m) { var v = m.querySelector('video'); if (v) { v.pause(); } }); }
}, 0.3);
show(0);
}
function initStories(scope) {
qa('[data-pz-story]', scope).forEach(function (el) {
if (el.__pzst) { return; }
el.__pzst = 1;
var steps = qa('[data-pz-step]', el);
if (el.getAttribute('data-mode') === 'play') { initPlayer(el, steps); } else { initScrub(el, steps); }
});
}

/* tilt + spotlight */
function initTilt(scope) {
if (!fine || reduce) { return; }
qa('[data-pz-tilt]', scope).forEach(function (el) {
if (el.__pzt) { return; }
el.__pzt = 1;
var max = parseFloat(el.getAttribute('data-pz-tilt')) || 5;
el.addEventListener('pointermove', function (e) {
var r = el.getBoundingClientRect();
var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
el.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
el.style.setProperty('--my', (y * 100).toFixed(1) + '%');
el.style.setProperty('--rx', ((0.5 - y) * max).toFixed(2) + 'deg');
el.style.setProperty('--ry', ((x - 0.5) * max).toFixed(2) + 'deg');
el.classList.add('is-hover');
});
el.addEventListener('pointerleave', function () {
el.style.setProperty('--rx', '0deg');
el.style.setProperty('--ry', '0deg');
el.classList.remove('is-hover');
});
});
}

/* tellers */
function initCount(scope) {
qa('[data-pz-count]', scope).forEach(function (el) {
if (el.__pzc) { return; }
el.__pzc = 1;
var end = parseFloat(el.getAttribute('data-pz-count'));
if (isNaN(end) || reduce) { return; }
el.textContent = '0';
vis(el, function (on) {
if (!on || el.__done) { return; }
el.__done = 1;
var start = performance.now();
(function f(now) {
var k = clamp((now - start) / 1500, 0, 1);
k = 1 - Math.pow(1 - k, 3);
el.textContent = Math.round(end * k);
if (k < 1) { requestAnimationFrame(f); }
})(start);
}, 0.6);
});
}

/* foto-reel */
function initReel(scope) {
qa('[data-pz-reel]', scope).forEach(function (el) {
if (el.__pzrl) { return; }
el.__pzrl = 1;
var track = el.querySelector('[data-pz-track]');
if (!track) { return; }
var bar = el.querySelector('[data-pz-reel-bar]');
var prev = el.querySelector('[data-pz-prev]'), next = el.querySelector('[data-pz-next]');
function stepBy(dir) {
var c = track.querySelector('.pz-reel__card');
var w = c ? c.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
track.scrollBy({ left: dir * w, behavior: 'smooth' });
}
if (prev) { prev.addEventListener('click', function () { stepBy(-1); }); }
if (next) { next.addEventListener('click', function () { stepBy(1); }); }
function upd() {
var max = track.scrollWidth - track.clientWidth;
var p = max > 0 ? track.scrollLeft / max : 1;
if (bar) { bar.style.transform = 'scaleX(' + (0.1 + 0.9 * p).toFixed(3) + ')'; }
if (prev) { prev.disabled = track.scrollLeft < 4; }
if (next) { next.disabled = track.scrollLeft > max - 4; }
}
track.addEventListener('scroll', upd, { passive: true });
window.addEventListener('resize', upd);
upd();
var down = false, sx = 0, sl = 0, moved = false;
track.addEventListener('pointerdown', function (e) {
if (e.pointerType !== 'mouse') { return; }
down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
});
window.addEventListener('pointermove', function (e) {
if (!down) { return; }
var dx = e.clientX - sx;
if (!moved && Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
if (moved) { track.scrollLeft = sl - dx; }
});
window.addEventListener('pointerup', function () {
if (!down) { return; }
down = false;
track.classList.remove('is-drag');
setTimeout(function () { moved = false; }, 0);
});
track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
});
}

/* lightbox */
var lb = null, lbItems = [], lbIdx = 0, lbZoom = false, lbLast = null;
function buildLb() {
if (lb) { return; }
lb = d.createElement('div');
lb.className = 'pz-lb';
lb.setAttribute('role', 'dialog');
lb.setAttribute('aria-modal', 'true');
lb.setAttribute('aria-label', 'Foto en video bekijken');
lb.innerHTML = '<div class="pz-lb__stage"></div><button type="button" class="pz-lb__btn pz-lb__close" aria-label="Sluiten">&times;</button><button type="button" class="pz-lb__btn pz-lb__prev" aria-label="Vorige">&#8249;</button><button type="button" class="pz-lb__btn pz-lb__next" aria-label="Volgende">&#8250;</button><div class="pz-lb__count"></div>';
d.body.appendChild(lb);
lb.querySelector('.pz-lb__close').addEventListener('click', closeLb);
lb.querySelector('.pz-lb__prev').addEventListener('click', function () { showLb(lbIdx - 1); });
lb.querySelector('.pz-lb__next').addEventListener('click', function () { showLb(lbIdx + 1); });
lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('pz-lb__stage')) { closeLb(); } });
d.addEventListener('keydown', function (e) {
if (!lb.classList.contains('is-open')) { return; }
if (e.key === 'Escape') { closeLb(); }
if (e.key === 'ArrowLeft') { showLb(lbIdx - 1); }
if (e.key === 'ArrowRight') { showLb(lbIdx + 1); }
});
var sx = null;
lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
lb.addEventListener('touchend', function (e) {
if (sx === null || lbZoom) { sx = null; return; }
var dx = e.changedTouches[0].clientX - sx;
if (Math.abs(dx) > 50) { showLb(lbIdx + (dx < 0 ? 1 : -1)); }
sx = null;
}, { passive: true });
}
function openLb(items, i) {
if (!items.length) { return; }
buildLb();
lbLast = d.activeElement;
lbItems = items;
lb.classList.toggle('is-single', items.length < 2);
lb.classList.add('is-open');
d.documentElement.classList.add('pz-lock');
showLb(i || 0);
lb.querySelector('.pz-lb__close').focus();
}
function closeLb() {
if (!lb) { return; }
lb.classList.remove('is-open');
d.documentElement.classList.remove('pz-lock');
var st = lb.querySelector('.pz-lb__stage');
var v = st.querySelector('video');
if (v) { v.pause(); }
st.innerHTML = '';
if (lbLast && lbLast.focus) { lbLast.focus(); }
}
function showLb(i) {
lbIdx = (i + lbItems.length) % lbItems.length;
lbZoom = false;
var it = lbItems[lbIdx];
var st = lb.querySelector('.pz-lb__stage');
if (it.type === 'video') {
st.innerHTML = '<video src="' + esc(it.src) + '" autoplay muted loop playsinline controls></video>';
} else {
st.innerHTML = '<img src="' + esc(it.src) + '" alt="' + esc(it.alt || '') + '">';
var img = st.querySelector('img');
var origin = function (e) {
if (!lbZoom) { return; }
var r = img.getBoundingClientRect();
img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
};
img.addEventListener('click', function (e) {
e.stopPropagation();
lbZoom = !lbZoom;
origin(e);
img.classList.toggle('is-zoom', lbZoom);
});
img.addEventListener('mousemove', origin);
}
lb.querySelector('.pz-lb__count').textContent = (lbIdx + 1) + ' / ' + lbItems.length;
}
function initLbGroups(scope) {
qa('[data-pz-lb-group]', scope).forEach(function (g) {
if (g.__pzg) { return; }
g.__pzg = 1;
var els = qa('[data-pz-lb-src]', g);
var items = els.map(function (a) { return { type: a.getAttribute('data-pz-lb-type') || 'image', src: a.getAttribute('data-pz-lb-src'), alt: a.getAttribute('data-pz-lb-alt') || '' }; });
els.forEach(function (a, i) { a.addEventListener('click', function (e) { e.preventDefault(); openLb(items, i); }); });
});
}

/* productgalerij: zoom, volledig scherm, video */
function bigSrc(im) {
if (!im) { return ''; }
var s = im.currentSrc || im.src || '';
return /[?&]width=\d+/.test(s) ? s.replace(/([?&])width=\d+/, '$1width=2000') : s;
}
function initGallery() {
var gal = d.querySelector('.product__media .gallery');
var cfg = window.PzEnhance;
if (!gal || !cfg || gal.__pz || d.querySelector('.pz-gal .pz-gal__slide')) { return; }
gal.__pz = 1;
var slides = qa('.gallery__slide', gal);
var items = slides.map(function (s) { var im = s.querySelector('img'); return { type: 'image', src: bigSrc(im), alt: im ? im.alt : '' }; }).filter(function (x) { return x.src; });
if (cfg.zoom && fine && !reduce) {
slides.forEach(function (s) {
var im = s.querySelector('img');
if (!im) { return; }
s.classList.add('pz-zoomable');
s.addEventListener('mousemove', function (e) {
var r = s.getBoundingClientRect();
im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
s.classList.add('is-zoom');
});
s.addEventListener('mouseleave', function () { s.classList.remove('is-zoom'); });
});
}
if (cfg.lightbox) {
slides.forEach(function (s, i) {
s.classList.add('pz-clickable');
s.addEventListener('click', function () { openLb(items, i); });
});
}
if (cfg.video) {
var chip = d.createElement('button');
chip.type = 'button';
chip.className = 'pz-chip';
chip.innerHTML = '<span class="pz-chip__dot" aria-hidden="true"></span>' + esc(cfg.videoLabel || 'Bekijk in actie');
chip.addEventListener('click', function (e) { e.stopPropagation(); openLb([{ type: 'video', src: cfg.video }].concat(items), 0); });
gal.appendChild(chip);
}
}

/* zwevende koopbalk + koopknoppen */
function mainBtn() { return d.querySelector('.product-form [name="add"], .product-form button[type="submit"]'); }
function initSticky() {
var bar = d.getElementById('PzSticky');
var btn = mainBtn();
if (!bar || !btn) { return; }
var foot = d.querySelector('.section-footer, footer');
function upd() {
var past = btn.getBoundingClientRect().bottom < 0;
var atFoot = foot ? foot.getBoundingClientRect().top < window.innerHeight - 40 : false;
var cta = d.querySelector('.pz-cta'); if (cta) { var cr = cta.getBoundingClientRect(); if (cr.top < window.innerHeight && cr.bottom > 0) { atFoot = true; } }
var on = past && !atFoot && !d.documentElement.classList.contains('pz-lock');
bar.classList.toggle('is-on', on);
bar.setAttribute('aria-hidden', on ? 'false' : 'true');
}
window.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
upd();
}
d.addEventListener('click', function (e) {
var b = e.target.closest ? e.target.closest('[data-pz-buy]') : null;
if (!b) { return; }
var m = mainBtn();
if (m && !m.disabled && m !== b) {
e.preventDefault();
b.classList.add('is-loading');
m.click();
}
});

/* interactieve productgalerij */
function initGal(scope) {
qa('[data-pz-gal]', scope).forEach(function (g) {
var slides = qa('.pz-gal__slide', g);
if (g.__pzgl || !slides.length) { return; }
g.__pzgl = 1;
var m = d.querySelector('.product__media');
if (m && g.parentNode !== m) {
qa('.pz-gal', m).forEach(function (o) { if (o !== g && o.parentNode) { o.parentNode.removeChild(o); } });
m.insertBefore(g, m.firstChild);
}
if (m) { m.classList.toggle('pz-gal-sticky', g.getAttribute('data-sticky') === 'true'); }
var stage = g.querySelector('.pz-gal__stage');
var thumbs = qa('[data-pz-gt]', g);
var tbar = g.querySelector('[data-pz-gthumbs]');
var tag = g.querySelector('[data-pz-gtag]');
var count = g.querySelector('[data-pz-gcount]');
var hint = g.querySelector('[data-pz-ghint]');
var prog = g.querySelector('[data-pz-gprog]');
var auto = g.getAttribute('data-auto') !== 'false';
var idx = -1, inView = true, praf = 0, sup = false, spin = null;
var items = [], map = [];
slides.forEach(function (s) {
var t = s.getAttribute('data-type'), vs = s.getAttribute('data-video'), im = s.querySelector('img');
if (t === 'spin') { map.push(-1); return; }
map.push(items.length);
items.push(vs ? { type: 'video', src: vs } : { type: 'image', src: s.getAttribute('data-big') || (im ? im.currentSrc || im.src : ''), alt: im ? im.alt : '' });
});
qa('video', g).forEach(function (v) {
v.muted = true; v.playsInline = true;
v.addEventListener('playing', function () { v.classList.add('is-ready'); });
v.addEventListener('seeked', function () { v.classList.add('is-ready'); });
});
function typ(i) { return slides[i] ? slides[i].getAttribute('data-type') : ''; }
function pad(x) { return (x < 10 ? '0' : '') + x; }
function closeSpots(sc) { qa('.pz-spot.is-open', sc || g).forEach(function (b) { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); }); }
function progLoop() {
cancelAnimationFrame(praf);
var s = slides[idx], v = s ? s.querySelector('video') : null;
if (!prog) { return; }
if (!v || typ(idx) !== 'video') { prog.style.transform = 'scaleX(0)'; return; }
(function f() {
if (v.duration) { prog.style.transform = 'scaleX(' + clamp(v.currentTime / v.duration, 0, 1).toFixed(4) + ')'; }
if (slides[idx] === s && inView) { praf = requestAnimationFrame(f); }
})();
}
function play(s) {
var v = s.querySelector('video');
if (!v || s.getAttribute('data-type') !== 'video') { return; }
ensureSrc(v);
if (inView && auto && !reduce) { playSafe(v); }
}
function show(i) {
i = (i + slides.length) % slides.length;
if (i === idx) { return; }
idx = i;
var s = slides[i], t = typ(i), lb = s.getAttribute('data-label') || '';
slides.forEach(function (x, j) {
var on = j === i;
x.classList.toggle('is-on', on);
x.setAttribute('aria-hidden', on ? 'false' : 'true');
if (on) { return; }
x.classList.remove('is-zoom');
closeSpots(x);
var v = x.querySelector('video');
if (v && x.getAttribute('data-type') === 'video') { v.pause(); try { v.currentTime = 0; } catch (e) {} }
});
thumbs.forEach(function (b, j) { b.classList.toggle('is-on', j === i); b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
if (tbar && thumbs[i]) {
var tb = thumbs[i], left = tb.offsetLeft - (tbar.clientWidth - tb.offsetWidth) / 2;
if (tbar.scrollTo) { tbar.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); } else { tbar.scrollLeft = left; }
}
if (tag) { tag.innerHTML = lb ? '<i></i>' + esc(lb) : ''; }
if (count) { count.textContent = pad(i + 1) + ' / ' + pad(slides.length); }
if (hint && t === 'spin') { var hs = hint.querySelector('span'); if (hs) { hs.textContent = s.getAttribute('data-hint') || ''; } }
g.classList.toggle('is-spin', t === 'spin');
g.classList.toggle('is-video', t === 'video');
if (t === 'video') { play(s); }
if (t === 'spin' && spin) { spin.tease(); }
progLoop();
}
function mkSpin(s) {
var v = s.querySelector('video');
if (!v) { return null; }
var ready = false, tgt = 0, cur = 0, raf = 0, vel = 0, drag = false, lx = 0, lt = 0, used = false, teased = false, over = 0;
v.addEventListener('loadeddata', function () { ready = true; });
function run() {
cancelAnimationFrame(raf);
raf = requestAnimationFrame(function f() {
if (!drag && Math.abs(vel) > 0.0003) { tgt = clamp(tgt + vel, 0, 1); vel *= 0.9; if (tgt === 0 || tgt === 1) { vel = 0; } }
cur += (tgt - cur) * 0.3;
if (Math.abs(tgt - cur) < 0.0005) { cur = tgt; }
if (ready && v.duration) {
var tt = cur * (v.duration - 0.05);
if (Math.abs(v.currentTime - tt) > 0.008) { try { v.currentTime = tt; } catch (e) {} }
}
if (drag || cur !== tgt || Math.abs(vel) > 0.0003) { raf = requestAnimationFrame(f); }
});
}
function tease() {
if (teased || used || reduce || !ready || !inView || slides[idx] !== s) { return; }
teased = true;
var t0 = performance.now();
(function f(now) {
if (used) { return; }
var k = (now - t0) / 2600;
tgt = k >= 1 ? 0 : Math.sin(k * Math.PI) * 0.22;
run();
if (k < 1) { requestAnimationFrame(f); }
})(t0);
}
function prime() {
if (v.__primed) { return; }
v.__primed = 1;
v.preload = 'auto';
ensureSrc(v);
var p = v.play();
if (p && p.then) { p.then(function () { v.pause(); ready = true; tease(); }).catch(function () { ready = true; }); }
}
return {
prime: prime,
tease: tease,
down: function (x) { prime(); used = true; drag = true; vel = 0; lx = x; lt = performance.now(); g.classList.add('is-grab'); if (hint) { hint.classList.add('is-off'); } run(); },
move: function (x) {
if (!drag) { return; }
var w = stage.clientWidth || 600, now = performance.now(), dp = (x - lx) / w * 0.9, raw = tgt + dp;
if (raw < 0 || raw > 1) { over = clamp(over + (x - lx) * 0.35, -30, 30); s.style.transform = 'translateX(' + over.toFixed(1) + 'px)'; } else if (over) { over = Math.abs(over) < 1 ? 0 : over * 0.6; s.style.transform = over ? 'translateX(' + over.toFixed(1) + 'px)' : ''; }
tgt = clamp(raw, 0, 1);
vel = dp / Math.max(8, now - lt) * 16;
lx = x; lt = now;
run();
},
up: function () {
if (!drag) { return; }
drag = false;
g.classList.remove('is-grab');
if (over) { over = 0; s.style.transition = 'transform .45s cubic-bezier(.2,.7,.2,1),opacity .6s'; s.style.transform = ''; setTimeout(function () { s.style.transition = ''; }, 500); }
run();
}
};
}
slides.forEach(function (s) { if (!spin && s.getAttribute('data-type') === 'spin') { spin = mkSpin(s); } });
if (spin) {
var pr = function () { setTimeout(spin.prime, 300); };
if (d.readyState === 'complete') { pr(); } else { window.addEventListener('load', pr); }
stage.addEventListener('pointerenter', function () { spin.prime(); });
}
var px = null, py = 0, mode = '', pid = null;
stage.addEventListener('pointerdown', function (e) {
if (e.pointerType === 'mouse' && e.button !== 0) { return; }
if (e.target.closest && e.target.closest('button')) { return; }
px = e.clientX; py = e.clientY; mode = ''; pid = e.pointerId;
if (e.pointerType === 'mouse' && spin && typ(idx) === 'spin') { mode = 'spin'; spin.down(px); try { stage.setPointerCapture(pid); } catch (er) {} }
});
stage.addEventListener('pointermove', function (e) {
if (px === null || e.pointerId !== pid) { return; }
var dx = e.clientX - px, dy = e.clientY - py;
if (!mode) {
if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
mode = spin && typ(idx) === 'spin' ? 'spin' : 'swipe';
if (mode === 'spin') { spin.down(px); }
try { stage.setPointerCapture(pid); } catch (er) {}
} else if (Math.abs(dy) > 8) { px = null; return; }
}
if (mode === 'spin') { spin.move(e.clientX); if (Math.abs(dx) > 6) { sup = true; } }
});
function endPtr(e) {
if (px === null || e.pointerId !== pid) { return; }
var dx = e.clientX - px;
if (mode === 'spin') { spin.up(); }
if (mode === 'swipe' && Math.abs(dx) > 45) { sup = true; show(idx + (dx < 0 ? 1 : -1)); }
px = null; mode = '';
}
stage.addEventListener('pointerup', endPtr);
stage.addEventListener('pointercancel', function () { if (mode === 'spin') { spin.up(); } px = null; mode = ''; });
stage.addEventListener('click', function (e) {
if (sup) { sup = false; return; }
if (e.target.closest && e.target.closest('button')) { return; }
var t = typ(idx);
if (t === 'spin') { return; }
if (t === 'spots' && g.querySelector('.pz-spot.is-open')) { closeSpots(); return; }
if (map[idx] >= 0) { openLb(items, map[idx]); }
});
if (fine && !reduce) {
stage.addEventListener('mousemove', function (e) {
var s = slides[idx];
if (!s || typ(idx) !== 'image' || px !== null) { return; }
var im = s.querySelector('img'), r = stage.getBoundingClientRect();
if (!im) { return; }
im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(2) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(2) + '%';
s.classList.add('is-zoom');
});
stage.addEventListener('mouseleave', function () { slides.forEach(function (s) { s.classList.remove('is-zoom'); }); });
}
stage.addEventListener('keydown', function (e) {
if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
});
qa('.pz-spot', g).forEach(function (b) {
var x = parseFloat(b.style.left), y = parseFloat(b.style.top);
if (x < 30) { b.classList.add('is-r'); } else if (x > 70) { b.classList.add('is-l'); }
if (y < 28) { b.classList.add('is-d'); }
function open() { closeSpots(); b.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }
b.addEventListener('click', function (e) { e.stopPropagation(); if (!fine && b.classList.contains('is-open')) { closeSpots(); } else { open(); } });
if (fine) {
b.addEventListener('mouseenter', open);
b.addEventListener('mouseleave', function () { closeSpots(); });
}
});
thumbs.forEach(function (b, j) { b.addEventListener('click', function () { show(j); }); });
var pv = g.querySelector('[data-pz-gprev]'), nx = g.querySelector('[data-pz-gnext]'), fs = g.querySelector('[data-pz-gfull]');
if (pv) { pv.addEventListener('click', function () { show(idx - 1); }); }
if (nx) { nx.addEventListener('click', function () { show(idx + 1); }); }
if (fs) { fs.addEventListener('click', function () { var k = map[idx]; openLb(items, k >= 0 ? k : 0); }); }
vis(g, function (on) {
inView = on;
var s = slides[idx], v = s ? s.querySelector('video') : null;
if (typ(idx) === 'spin') { if (on && spin) { spin.tease(); } return; }
if (!v || typ(idx) !== 'video') { return; }
if (on && auto && !reduce) { playSafe(v); progLoop(); } else { v.pause(); }
}, 0.25);
g.__show = show;
g.__slides = slides;
show(0);
});
}
d.addEventListener('shopify:block:select', function (e) {
var det = e.detail || {}, el = e.target, g = el && el.closest ? el.closest('.pz-gal') : null, i = g && g.__slides ? g.__slides.indexOf(el) : -1;
if (i < 0 && det.blockId) { qa('.pz-gal').forEach(function (x) { if (i > -1 || !x.__slides) { return; } x.__slides.some(function (s, j) { if ((s.getAttribute('data-shopify-editor-block') || '').indexOf(det.blockId) > -1) { g = x; i = j; return true; } return false; }); }); }
if (g && g.__show && i > -1) { g.__show(i); }
});
d.addEventListener('shopify:section:unload', function (e) {
var id = e.detail && e.detail.sectionId;
qa('.pz-gal').forEach(function (x) { if (x.getAttribute('data-sid') === id && x.parentNode) { x.parentNode.removeChild(x); } });
var m = d.querySelector('.product__media');
if (m && !m.querySelector('.pz-gal')) { m.classList.remove('pz-gal-sticky'); }
});

function initAll(scope) {
initReveal(scope);
initScroll(scope);
initAutoplay(scope);
initStories(scope);
initTilt(scope);
initCount(scope);
initReel(scope);
initLbGroups(scope);
initGal(scope);
}
function boot() { initAll(d); initGallery(); initSticky(); tick(); }
if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
d.addEventListener('shopify:section:load', function (e) { initAll(e.target); initGal(d); tick(); });
})();
